module.exports = __webpack_public_path__ + "img/vip-coupon-ratio.0ad75698.png";